import { Popover } from 'bootstrap/dist/js/bootstrap.bundle';

const STICKY_CLASS = 'sticky';
const HIDDEN_CLASS = 'displayNone';

function initUserCardPopover() {
    const trigger = document.getElementById('searchBarUserIconButton');
    const source = document.querySelector('.searchBarUserContainer');
    if (trigger === null || source === null) {
        return;
    }

    new Popover(trigger, {
        container: 'body',
        html: true,
        content: () => {
            const clone = source.cloneNode(true);
            clone.style.display = '';
            return clone;
        },
        sanitize: false,
        customClass: 'searchBarUserCardPopover',
    });
}

function initSticky() {
    const searchBar = document.getElementById('mainSearchBar');
    const placeholder = document.getElementById('mainSearchBarPlaceholder');
    if (searchBar === null || placeholder === null) {
        return;
    }

    let isSticky = false;

    const update = () => {
        const searchBarRect = searchBar.getBoundingClientRect();

        if (!isSticky && searchBarRect.top <= 0) {
            placeholder.style.height = `${searchBarRect.height}px`;
            searchBar.classList.add(STICKY_CLASS);
            isSticky = true;
        } else if (isSticky && placeholder.getBoundingClientRect().top > 0) {
            searchBar.classList.remove(STICKY_CLASS);
            placeholder.style.height = '0';
            isSticky = false;
        }
    };

    window.addEventListener('scroll', update, { passive: true });
    update();
}

function initHint() {
    const hint = document.getElementById('searchBarHint');
    const toggle = document.getElementById('searchBarHintToggle');
    if (hint === null || toggle === null) {
        return;
    }

    const toggleHint = () => hint.classList.toggle(HIDDEN_CLASS);

    toggle.addEventListener('click', toggleHint);
    hint.addEventListener('click', toggleHint);
}

function initLanguageSwitch() {
    // The select lives in a clone of the user card rendered by the popover, so the handler has to be delegated
    $(document).on('change', '#select-language', function () {
        const language = ($(this).val() || '').toString().trim();
        if (language === '') {
            return;
        }

        const url = new URL(window.location.href);
        url.searchParams.set('switch_language', language);
        window.location.href = url;
    });
}

$(function () {
    initUserCardPopover();
    initSticky();
    initHint();
    initLanguageSwitch();
});
